export enum LinkOpenPolicy {
  ALL_IN_NEW_TAB = 'ALL_IN_NEW_TAB',
  EXTERNAL_IN_NEW_TAB = 'EXTERNAL_IN_NEW_TAB',
  NONE = 'NONE',
}
